// extracted by mini-css-extract-plugin
module.exports = {"notesTextarea":"styles_notesTextarea__2G1Vu"};